// Is this chat message data (page content, a structured card) rather than text to show? Only when it
// IS data: an array, or text that starts with "{", "[" or "<". It used to hide any message that merely
// contained a "{" or "<", so ordinary replies could vanish (CoPilot spec bug #8, Oct 27 2026).
export const looksLikeData = (caption: unknown): boolean => {
  if (Array.isArray(caption)) return true;
  if (typeof caption !== "string") return false;
  if (caption.startsWith("Error: ")) return false;
  return /^\s*[{[<]/.test(caption);
};
